<div class="lpr-source-dropdown-entry__provider-group">
  <div
    class="lpr-source-dropdown-entry__provider-group-header lpr-source-dropdown-entry__provider-group-row"
    [class.lpr-source-dropdown-entry__provider-group-row--selected]="providerCheckbox?.checked"
  >
    <mat-checkbox
      #providerCheckbox
      [color]="'primary'"
      [disableRipple]="true"
      [name]="isWorksWithAxon ? worksWithAxonCheckboxName : (provider$ | async).name"
      [disabled]="!(isProviderLoaded$ | async)"
      [ngModel]="providerCheckbox$ | async"
      (ngModelChange)="providerCheckbox$.next($event)"
      >{{ providerNameTranslationKey | t }}</mat-checkbox
    >
    <mat-spinner
      *ngIf="isWorksWithAxon ? false : !(isProviderLoaded$ | async)"
      [diameter]="20"
    ></mat-spinner>
    <div
      *ngIf="isProviderLoaded$ | async"
      class="lpr-source-dropdown-entry__provider-group-row-details"
    >
      <sn-icon
        *ngIf="
          (hasProviderWarnings$ | async) &&
          !(shouldShowPartialMatches$ | async) &&
          providerCheckbox?.checked
        "
        [matTooltip]="providerWarningMessages$ | async"
        [matTooltipPosition]="'right'"
        [matTooltipClass]="'lpr-source-dropdown-entry__issue-tooltip'"
        class="lpr-source-dropdown-entry__warning-icon"
        fontIcon="fa-triangle-exclamation"
        fontSet="fa"
        data-testid="provider-warning-icon"
      ></sn-icon>
      <sn-icon
        *ngIf="(hasProviderErrors$ | async) && providerCheckbox?.checked"
        [matTooltip]="providerErrorMessages$ | async"
        [matTooltipPosition]="'right'"
        [matTooltipClass]="'lpr-source-dropdown-entry__issue-tooltip'"
        class="lpr-source-dropdown-entry__error-icon"
        fontIcon="fa-triangle-exclamation"
        fontSet="fa"
        data-testid="provider-error-icon"
      ></sn-icon>
      <span class="lpr-source-dropdown-entry__provider-group-row-count">
        {{ providerCount$ | async }}
      </span>
    </div>
  </div>
  <ng-container *ngIf="cameraModels$">
    <div
      *ngFor="let cameraModel of cameraModels$ | async"
      class="lpr-source-dropdown-entry__provider-group-row lpr-source-dropdown-entry__provider-group-row--camera-model"
      [class.lpr-source-dropdown-entry__provider-group-row--selected]="cameraModelCheckbox.checked"
    >
      <!--
        Use cameraModel.model directly instead of cameraModelCheckbox.name to avoid race conditions
        with template reference variables during async evaluation
      -->
      <mat-checkbox
        #cameraModelCheckbox
        [color]="'primary'"
        [disableRipple]="true"
        [name]="cameraModel.model"
        [disabled]="!(isProviderLoaded$ | async)"
        [ngModel]="(cameraModelSelection$ | async)?.cameraModels?.get(cameraModel.model) ?? false"
        (ngModelChange)="cameraModelCheckbox$.next({ name: cameraModel.model, isSelected: $event })"
        [attr.data-testid]="'source-dropdown-camera-model-' + (cameraModel.model | fsAxonViLPRCameraModel).toLowerCase().split(' ').join('-')"
      >
        {{ cameraModel.model | fsAxonViLPRCameraModel }}
      </mat-checkbox>
      <div class="lpr-source-dropdown-entry__provider-group-row-details">
        <span
          *ngIf="isProviderLoaded$ | async"
          class="lpr-source-dropdown-entry__provider-group-row-count"
        >
          {{ cameraModel.count }}
        </span>
      </div>
    </div>
  </ng-container>
</div>
